<template>
  <div
    data-v-bf1681ae=""
    class="modal"
    style="display: block; background-color: rgba(0, 0, 0, 0.5);"
    @click="$emit('onHide')"
  >
    <div
      data-v-bf1681ae=""
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      class="modal fade show"
      style="display: block;"
    >
      <div
        data-v-bf1681ae=""
        role="document"
        class="modal-dialog modal-dialog-centered"
      >
        <div data-v-bf1681ae="" class="modal-content" @click.stop>
          <div
            data-v-bf1681ae=""
            class="modal-header"
            style="border-bottom: none;"
          >
            <button
              data-v-bf1681ae=""
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
              @click="$emit('onHide')"
            >
              <span data-v-bf1681ae="" aria-hidden="true">×</span>
            </button>
          </div>
          <div data-v-bf1681ae="" class="modal-body text-center">
            <h3 data-v-bf1681ae="">
              {{ $t("Sei sicuro di voler eliminare il tuo account?") }}
            </h3>
            <h4 data-v-bf1681ae="">
              {{ $t("Questa azione è irreversibile") }}
            </h4>
          </div>
          <div
            data-v-bf1681ae=""
            class="modal-footer text-center"
            style="border-top: none;"
          >
            <button
              data-v-bf1681ae=""
              class="btn btn-danger btn-block"
              @click="onAction"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: ["onAction"]
};
</script>

<style></style>
